
export const DownIcon = (props) => (
  <svg {...props} width="14" height="9" viewBox="0 0 14 9" fill="none" stroke="#63637c" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L7 7L13 1" strokeWidth="1.5" />
  </svg>
);
